import { Button, Icon, SyntheticButton } from '@yes.technology/react-toolkit'

import { useTranslation } from 'react-i18n-lite'

import { ArrayFieldValue, GroupedFieldValues } from '../../types'

import { useMemo } from 'react'
import {
  SelectAndLinkSessionConfig,
  useSelectAndLink
} from 'site/Renderer/components/SelectAndLink'
import { targetComponents } from 'site/Renderer/components/SelectAndLink/SelectAndLink.constants'
import { Actions, Container } from './Field.styles'

type RelationDataFieldProps = {
  objectclassUuid: string
  name?: string
  label?: string
  children: React.ReactNode
  groupedFieldValues: GroupedFieldValues
  displayActions?: boolean
  groupPosition: number
  selectedOptions: ArrayFieldValue
  selectAndLinkTargetPath?: string
}

const RelationDataField = ({
  name,
  label,
  objectclassUuid,
  groupedFieldValues,
  displayActions,
  groupPosition,
  children,
  selectAndLinkTargetPath
}: RelationDataFieldProps) => {
  const { openSelectAndLink } = useSelectAndLink()

  const selectAndLinkConfig: SelectAndLinkSessionConfig = useMemo(() => {
    const targetField = name || ''
    const targetGroup = String(groupPosition)
    const selectedOptions = (groupedFieldValues[targetGroup]?.[targetField]
      ?.value ?? []) as ArrayFieldValue

    return {
      targetField,
      targetGroup,
      objectclassUuid: objectclassUuid || '',
      targetComponent: targetComponents.FILTER_FIELDS,
      targetPath: selectAndLinkTargetPath,
      selectedOptions,
      objectClassTitle: label || ''
    }
  }, [
    name,
    groupPosition,
    objectclassUuid,
    selectAndLinkTargetPath,
    groupedFieldValues,
    label
  ])

  const { t } = useTranslation()

  const actionButtons = [
    {
      children: <Icon iconName='SelectAndRelateSign' />,
      title: t('select-and-link.action'),
      onClick: () => openSelectAndLink(selectAndLinkConfig)
    }
  ]

  return (
    <Container {...{ displayActions }}>
      {children}
      {displayActions && (
        <Actions>
          {actionButtons.length === 1 ? (
            <Button
              variant='secondary'
              title={actionButtons[0].title}
              onClick={actionButtons[0].onClick}
              style={{ minWidth: '40px' }}
            >
              {actionButtons[0].children}
            </Button>
          ) : (
            <SyntheticButton
              options={actionButtons}
              heightClass='regular'
              dropdownLabel='options'
              variant='secondary'
            />
          )}
        </Actions>
      )}
    </Container>
  )
}

export default RelationDataField
